// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patientsViewer_header__QFWp8 {
    background-color: var(--secondary-color);
    height: 8rem;
    border-radius: .2rem;
}

.patientsViewer_image__VqxOs {
    width: 10rem;
    height: auto;
}

.patientsViewer_text__SlfL6 {
    margin: .5rem 0 0 1rem;
}

.patientsViewer_whiteText__sb4UV {
    color: white;
}

.patientsViewer_tabsSection__hqAy3 {
    margin-top: 4rem;
}

.patientsViewer_formLabel__\\+pPS3 {
    margin: 0.5rem 1rem .5rem 0;
}

.patientsViewer_inputGroupContainer__J\\+cgs {
    width: 100%;
}

.patientsViewer_largeButton__SSx\\+1 {
    width: 14rem;
    height: 2.6rem;
    margin-top: 1rem;
}

.patientsViewer_noteSection__tOiVJ {
    margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientsViewer/patientsViewer.module.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".header {\n    background-color: var(--secondary-color);\n    height: 8rem;\n    border-radius: .2rem;\n}\n\n.image {\n    width: 10rem;\n    height: auto;\n}\n\n.text {\n    margin: .5rem 0 0 1rem;\n}\n\n.whiteText {\n    color: white;\n}\n\n.tabsSection {\n    margin-top: 4rem;\n}\n\n.formLabel {\n    margin: 0.5rem 1rem .5rem 0;\n}\n\n.inputGroupContainer {\n    width: 100%;\n}\n\n.largeButton {\n    width: 14rem;\n    height: 2.6rem;\n    margin-top: 1rem;\n}\n\n.noteSection {\n    margin-top: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `patientsViewer_header__QFWp8`,
	"image": `patientsViewer_image__VqxOs`,
	"text": `patientsViewer_text__SlfL6`,
	"whiteText": `patientsViewer_whiteText__sb4UV`,
	"tabsSection": `patientsViewer_tabsSection__hqAy3`,
	"formLabel": `patientsViewer_formLabel__+pPS3`,
	"inputGroupContainer": `patientsViewer_inputGroupContainer__J+cgs`,
	"largeButton": `patientsViewer_largeButton__SSx+1`,
	"noteSection": `patientsViewer_noteSection__tOiVJ`
};
export default ___CSS_LOADER_EXPORT___;
